export default "__VITE_ASSET__C9zAEl13__"